// React imports.
import React from "react";

//app imports
import {Assessment3VendorAssignedStatusEnum} from "../state";
import {Assessment3HHDataReceivedStatusEnum} from "../state";
import {Assessment3HHVendorsSelectedStatusEnum} from "../state";
import {Assessment3HHServedByVendorsProvidingDataStatusEnum} from "../state";
import {Assessment3RateOfReturnStatusEnum} from "../state";


const Assessment3Sup3TableRow = ({ state, fuel, rowClass }) => (
    <React.Fragment>
      <div className={"dwGridRow col1 "+ rowClass}>{fuel.description}</div>
        {state.Assessment3Steps[state.CurrentAssessementStepIndex].showNumHouseholdsServedByVendorsProvidingData === true &&
            <div className={"dwGridRow col2 yellow-background "+ rowClass}>
                <input id="numHouseholdsServedByVendorsProvidingData" value={fuel.numHouseholdsServedByVendorsProvidingData }
                    onChange={(changeEvent) => state.assessment3FieldChangeHandler(changeEvent, fuel)} 
                    className="form-control "  />
            </div>
        }
        {state.Assessment3Steps[state.CurrentAssessementStepIndex].showNumHouseholdsDataReceived2 === true &&
            <div className={"dwGridRow col3 blue-background "+ rowClass}>
                <input id="numHouseholdsDataReceived" value={fuel.numHouseholdsDataReceived }
                    onChange={(changeEvent) => state.assessment3FieldChangeHandler(changeEvent, fuel)} 
                    className="form-control "  />
            </div>
        }
        {state.Assessment3Steps[state.CurrentAssessementStepIndex].showPercentRateOfReturn === true &&
            <React.Fragment>
                {(fuel.rateOfReturnStatus ==Assessment3RateOfReturnStatusEnum.Over75NoIssues)
                    &&<div className={"dwGridRow col4 green-background "+ rowClass} >{fuel.percentRateOfReturn}</div>
                }
                {(fuel.rateOfReturnStatus ===Assessment3RateOfReturnStatusEnum.Under75NotMeetTarget)
                    &&<div className={"dwGridRow col4 red-background "+ rowClass} >{fuel.percentRateOfReturn}</div>
                }
            </React.Fragment>
        }
        {state.Assessment3Steps[state.CurrentAssessementStepIndex].showRateOfReturnStatus === true &&
            <React.Fragment>
                {(fuel.rateOfReturnStatus ==Assessment3RateOfReturnStatusEnum.Over75NoIssues)
                    &&<div className={"dwGridRow col5 green-background "+ rowClass}>
                          <span>
                              <strong>No Issue Flagged –</strong>
                              The vendors that complied with your data request
                              suppled data for at least 75% of
                              the  {fuel.description}  households they serve.
                          </span>
                      </div>
                }
                {(fuel.rateOfReturnStatus ===Assessment3RateOfReturnStatusEnum.Under75NotMeetTarget)
                    &&<div className={"dwGridRow col5 red-background "+ rowClass}>
                          <span>
                              <strong>Potential Issue  –</strong>
                              The vendors that complied with your data request DID NOT
                              supply data for at least 75% of
                              the  {fuel.description}  households they serve.
                          </span>
                    </div>
                }
            </React.Fragment>
        }
    </React.Fragment>
);

export default Assessment3Sup3TableRow;
